import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListarArchivosSap() {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filesIn, setFilesIn] = useState([]);
  const [filesOut, setFilesOut] = useState([]);

  // =========================
  // CARGA INICIAL
  // =========================
  useEffect(() => {
    const loadFiles = async () => {
      try {
        const data = await appFetchJson(
          apiRoutes.procesos.listFiles,
          { method: "GET" },
          { showLoading: false }
        );

        setFilesIn(data?.in || []);
        setFilesOut(data?.out || []);
      } catch (e) {
        console.error(e);
        setError("No se pudieron cargar los archivos SAP.");
      } finally {
        setLoading(false);
      }
    };

    loadFiles();
  }, []);

  // =========================
  // RENDER
  // =========================
  return (
    <div className="page">
      <h1 className="page-title">Archivos de Interfase SAP</h1>

      <div className="card mt-6">
        {loading && <p>Cargando archivos…</p>}

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        {!loading && !error && (
          <div className="grid grid-cols-2 gap-8">

            {/* ================= IN ================= */}
            <div>
              <h3 className="font-semibold mb-2">
                Recibidos del SAP (PROANI-IN)
              </h3>
              <hr className="mb-3" />

              {filesIn.length === 0 ? (
                <p className="text-muted">Sin archivos</p>
              ) : (
                <ul className="space-y-1">
                  {filesIn.map((f, i) => (
                    <li key={i}>
                      <span className="text-sm">{f.nombre}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* ================= OUT ================= */}
            <div>
              <h3 className="font-semibold mb-2">
                Para envío al SAP (PROANI-OUT)
              </h3>
              <hr className="mb-3" />

              {filesOut.length === 0 ? (
                <p className="text-muted">Sin archivos</p>
              ) : (
                <ul className="space-y-1">
                  {filesOut.map((f, i) => (
                    <li key={i}>
                      <span className="text-sm">{f.nombre}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>
        )}
      </div>
    </div>
  );
}
